// i18next-extract-mark-ns-start common
import React, { Fragment } from 'react';
import People from '../contact/People';
import { GatsbyImage } from 'gatsby-plugin-image';
import EventCarousel from '../event/EventCarousel';
import { useTranslation } from 'gatsby-plugin-react-i18next';

const TagDetail = ({ data, locale, pageContext }) => {
  const tag = data.tagsYaml;
  const people = data.allPeopleYaml.nodes;
  const posts = data.allMdx.edges;
  const events = data.allEventYaml.nodes;
  const { t } = useTranslation();

  return (
    <Fragment>
      <div className="bg-white py-12">
        <div className="mx-auto max-w-6xl px-6 lg:px-8">
          <div className="grid grid-cols-4 items-center gap-x-8">
            <div className="mx-auto col-span-4 lg:col-span-3 lg:mx-0 order-last lg:order-first">
              <h2 className="text-3xl font-bold tracking-tight text-gray-900">
                {tag.name}
              </h2>
              <p className="mt-6 text-lg leading-8 text-gray-600">
                {tag.description}
              </p>
              <div className="mt-8 items-center gap-x-6">
                <a
                  href={tag.url}
                  className="rounded-md bg-adw-blue px-3.5 py-2.5 text-sm font-semibold
                text-white shadow-sm"
                >
                  {t('Navštíviť stránku')}
                </a>
              </div>
            </div>
            <div className="mx-auto col-span-4 lg:col-span-1 justify-self-center lg:justify-self-end items-center lg:mx-0 order-first lg:order-last">
              <GatsbyImage
                objectFit="contain"
                className="object-contain"
                style={{ width: '12rem', height: '12rem' }}
                image={tag.logo.childImageSharp.gatsbyImageData}
              />
            </div>
          </div>
        </div>
      </div>

      {posts.length > 0 && (
        <div className="bg-gray-100 py-12 sm:py-16">
          <div className="mx-auto max-w-6xl px-6 lg:px-8">
            <div className="mx-auto max-w-2xl text-center">
              <h2 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
                {t('Blogy s tagom')} {tag.name}
              </h2>
            </div>
            <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
              {posts.map(post => (
                <article
                  key={post.id}
                  className="flex flex-col items-start justify-between"
                >
                  <div className="relative w-full">
                    <GatsbyImage
                      objectFit="scale-down"
                      className=" w-full rounded-2xl bg-gray-100 object-cover "
                      image={
                        post.node.frontmatter.image.childImageSharp
                          .gatsbyImageData
                      }
                    />
                    <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10" />
                  </div>
                  <div className="max-w-xl">
                    <div className="mt-8 flex items-center gap-x-4 text-xs">
                      <time className="text-gray-500">
                        {post.node.frontmatter.date}
                      </time>
                    </div>
                    <div className="group relative">
                      <h3 className="mt-3 text-lg font-semibold leading-6 text-gray-900 group-hover:text-gray-600">
                        <a
                          href={
                            '/' +
                            post.node.frontmatter.language +
                            '/' +
                            post.node.frontmatter.kind +
                            post.node.frontmatter.uri
                          }
                        >
                          <span className="absolute inset-0" />
                          {post.node.frontmatter.title}
                        </a>
                      </h3>
                      <p className="mt-5 line-clamp-3 text-sm leading-6 text-gray-600">
                        {post.node.excerpt}
                      </p>
                    </div>
                    <div className="relative mt-8 flex items-center gap-x-4">
                      <GatsbyImage
                        objectFit="contain"
                        className="rounded-full bg-gray-50"
                        style={{ width: '2.5rem', height: '2.5rem' }}
                        image={
                          post.node.frontmatter.author.photo.childImageSharp
                            .gatsbyImageData
                        }
                      />
                      <div className="text-sm leading-6">
                        <p className="font-semibold text-gray-900">
                          <button>
                            <span className="absolute inset-0" />
                            {post.node.frontmatter.author.name}
                          </button>
                        </p>
                        <p className="text-gray-600">
                          {post.node.frontmatter.author.role}
                        </p>
                      </div>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      )}

      {people.length > 0 && (
        <People
          people={people}
          title={t('Naši ') + tag.name + t(' špecialisti')}
        />
      )}

      {events.length > 0 && (
        <div className="bg-gray-100 py-12">
          <div className="mx-auto max-w-8xl px-6 lg:px-8">
            <div className="mx-auto max-w-2xl lg:max-w-6xl">
              <p className="mb-10 text-xl leading-8 text-black font-bold">
                {t('Eventy s tagom')} {tag.name}
              </p>
              <EventCarousel slides={events} allButton={false} />
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default TagDetail;
